class AthletesPage extends HTMLElement {
  constructor() {
    super();
    this.heroIntervalId = null;
    this.heroSlideIndex = 0;
    this.onFilterSelectChange = this.onFilterSelectChange.bind(this);
    this.onFilterTabClick = this.onFilterTabClick.bind(this);
    this.onHeroResize = this.onHeroResize.bind(this);
  }

  connectedCallback() {
    this.filterTabs = Array.from(this.querySelectorAll('[data-athlete-filter]'));
    this.filterSelect = this.querySelector('[data-athlete-filter-select]');
    this.tiles = Array.from(this.querySelectorAll('[data-categories]'));
    this.heroCarousel = this.querySelector('[data-athletes-hero-carousel]');
    this.heroSlides = this.heroCarousel
      ? Array.from(this.heroCarousel.querySelectorAll('[data-hero-slide]'))
      : [];
    this.heroSpeed = Number(this.heroCarousel?.dataset.speed || 5000);

    this.setupFilters();
    this.setupHeroCarousel();
  }

  disconnectedCallback() {
    this.clearHeroAutoplay();
    window.removeEventListener('resize', this.onHeroResize);

    this.filterTabs.forEach((tab) => {
      tab.removeEventListener('click', this.onFilterTabClick);
    });

    if (this.filterSelect) {
      this.filterSelect.removeEventListener('change', this.onFilterSelectChange);
    }
  }

  setupFilters() {
    this.filterTabs.forEach((tab) => {
      tab.addEventListener('click', this.onFilterTabClick);
    });

    if (this.filterSelect) {
      this.filterSelect.addEventListener('change', this.onFilterSelectChange);
    }
  }

  onFilterTabClick(event) {
    const button = event.currentTarget;
    if (!(button instanceof HTMLButtonElement)) {
      return;
    }

    this.applyFilter(button.dataset.athleteFilter || 'all');
  }

  onFilterSelectChange(event) {
    const select = event.currentTarget;
    if (!(select instanceof HTMLSelectElement)) {
      return;
    }

    this.applyFilter(select.value || 'all');
  }

  applyFilter(filterValue) {
    const normalizedFilter = filterValue || 'all';

    this.tiles.forEach((tile) => {
      const categories = (tile.dataset.categories || '')
        .split(',')
        .map((category) => category.trim())
        .filter(Boolean);
      const isVisible =
        normalizedFilter === 'all' || categories.includes(normalizedFilter);
      tile.classList.toggle('athlete-tile--hidden', !isVisible);
      tile.toggleAttribute('hidden', !isVisible);
    });

    this.filterTabs.forEach((tab) => {
      const isActive = tab.dataset.athleteFilter === normalizedFilter;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    if (this.filterSelect && this.filterSelect.value !== normalizedFilter) {
      this.filterSelect.value = normalizedFilter;
    }
  }

  setupHeroCarousel() {
    if (!this.heroCarousel || this.heroSlides.length <= 1) {
      return;
    }

    window.addEventListener('resize', this.onHeroResize);
    this.onHeroResize();
  }

  onHeroResize() {
    const isDesktop = window.matchMedia('(min-width: 1200px)').matches;

    if (!isDesktop) {
      this.clearHeroAutoplay();
      this.setHeroSlide(0, false);
      return;
    }

    this.clearHeroAutoplay();
    this.setHeroSlide(this.heroSlideIndex, false);
    this.heroIntervalId = window.setInterval(() => {
      const nextIndex = (this.heroSlideIndex + 1) % this.heroSlides.length;
      this.setHeroSlide(nextIndex, true);
    }, this.heroSpeed);
  }

  setHeroSlide(index, animate) {
    if (!this.heroSlides.length) {
      return;
    }

    const nextIndex =
      ((index % this.heroSlides.length) + this.heroSlides.length) % this.heroSlides.length;

    if (!animate) {
      this.heroSlides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === nextIndex);
      });
      this.heroSlideIndex = nextIndex;
      return;
    }

    this.heroSlides.forEach((slide, slideIndex) => {
      slide.classList.toggle('is-active', slideIndex === nextIndex);
    });

    this.heroSlideIndex = nextIndex;
  }

  clearHeroAutoplay() {
    if (this.heroIntervalId) {
      window.clearInterval(this.heroIntervalId);
      this.heroIntervalId = null;
    }
  }
}

if (!customElements.get('athletes-page')) {
  customElements.define('athletes-page', AthletesPage);
}
